import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatMessageActionButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== '$visible',
})<{ $visible: boolean }>(({ $visible }) => ({
  opacity: $visible ? 1 : 0,
  pointerEvents: $visible ? 'auto' : 'none',
  '&:focus-visible': { opacity: 1 },
}));
